import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import config from '../config';
import {devOpsUrlFor} from './devOpsUrl';

/**
 * FNP-1649: Platform Controls moved to the platform application
 * (platform.<stage>.flexi.network). A bookmarked Console URL for it lands on
 * the same page there instead of the Console's 404 page.
 *
 * Same shape as RedirectToDevOps (FNP-1636). `devOpsUrlFor` is a plain
 * base + path join with nothing DevOps-specific in it, so it is reused here.
 * `location.replace`, so the dead Console URL does not stay in the history.
 */
export const RedirectToPlatform = ({base = config.platform.platform}: {base?: string}) => {
    const {pathname, search, hash} = useLocation();

    useEffect(() => {
        window.location.replace(devOpsUrlFor(base, pathname, search, hash));
    }, [base, pathname, search, hash]);

    return null;
};
